export default __webpack_public_path__ + "static/media/parcela_7.0dd12784.png";